import { render } from "./LeftSidebarTabs.vue?vue&type=template&id=32cf2d90&scoped=true"
import script from "./LeftSidebarTabs.vue?vue&type=script&lang=js"
export * from "./LeftSidebarTabs.vue?vue&type=script&lang=js"

import "./LeftSidebarTabs.vue?vue&type=style&index=0&id=32cf2d90&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cf2d90"]])

export default __exports__